export const config = {
  apiBaseUrl: 'https://18z87gg9v1.execute-api.us-east-1.amazonaws.com/prod',
  stripePublicKey: 'pk_live_51S0YrIPyiM7Fj0JorTU3peJt3d0jqwApLCumGmZ3S4ajfSm5GiAVPlYTkeVagODQKQSgbJZcMgESYKI3NHq2lURw00hGK2KfeP',
  environment: 'production',
};
